import React from 'react';
import PropTypes from 'prop-types';
import {TweenMax, Power1} from 'gsap';
import classNames from 'classnames';

export default class PageLoader extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    if (this.props.isLoading) {
      this.createTweens();
      this.loopTweens();
    }
  }

  /**
   * React Lifecycle Hook
   * Invoked before a mounted component receives new props. If you need to
   * update the state in response to prop changes, you may compare this.props
   * and nextProps and perform state transitions
   *
   * @method  componentWillReceiveProps
   */
  componentWillReceiveProps(nextProps) {
    const starting = nextProps.isLoading && !this.props.isLoading;
    const stopping = !nextProps.isLoading && this.props.isLoading;

    if (starting) {
      if (this.loadTween) {
        this.loadTween.restart(0);
        clearInterval(this.tweenLoop);
        this.loopTweens();
      } else {
        this.createTweens();
        this.loopTweens();
      }
    } else if (stopping) {
      clearInterval(this.tweenLoop);
    }
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    this.killAnimation();
  }

  createTweens() {
    const stageTwo = () => {
      TweenMax.to(this.loader, 0.5, {
        'delay': 0.1,
        'x': window.innerWidth*2,
        'ease': Power1.easeIn,
        'onComplete': () => {
          if (this.loader) {
            this.loader.setAttribute('style', '');
          }
        }
      });
    };

    this.loadTween = TweenMax.to(this.loader, 0.5, {
      'x': window.innerWidth,
      'ease': Power1.easeOut,
      'onComplete': stageTwo
    });
  }

  loopTweens() {
    this.tweenLoop = setInterval(() => {
      if (this.props.isLoading) {
        this.loadTween.restart(0);
      }
    }, 1150);
  }

  killAnimation() {
    if (this.loadTween) {
      this.loadTween.kill();
    }

    if (this.tweenLoop) {
      clearInterval(this.tweenLoop);
    }
  }

  render() {
    const loaderClasses = classNames(
      'page-loader',
      {
        'page-loader_fixed': this.props.fixedLoader
      }
    );

    return (
      <div className={loaderClasses} ref={el => { this.loader = el; }}>
      </div>
    )
  }
}

PageLoader.propTypes = {
  'fixedLoader': PropTypes.bool,
  'isLoading': PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/client/components/page/page-loader.jsx